'use strict';

import moment from 'moment';
import variant from 'Functions/variant';
import Image from 'Pure/Image';
import Logo from 'Pure/Logo';
import bemit from 'Functions/bemit';
import { b_seminars_config, days_config } from 'Shared/options';
import { num, formatNum, isTrue } from 'Shared/utilities';
const {
  app
} = window;
export default function BookingServicesInfosCard({
  booking,
  ...props
}) {
  const space = booking?.coworking_space;
  const booking_services = props.booking_services;
  if (!space?.type || !booking?.date || !booking_services) return null;
  const services = Array.isArray(booking.services) ? booking.services : [];
  let amount_without_services = num(booking.amount);
  const day_name = days_config[moment(booking.date).isoWeekday() - 1];
  const schedule_config = (space?.schedule || {})[day_name] || {};
  let hours_section;
  if (['b_seminar', 'c_open_coworking_space'].includes(space?.type)) {
    const morning = [num(schedule_config.morning_from, 0) + 'h', num(schedule_config.morning_to, 0) + 'h'].join('-');
    const afternoon = [num(schedule_config.afternoon_from, 0) + 'h', num(schedule_config.afternoon_to, 0) + 'h'].join('-');
    const lunch_break = booking.start_hour === 'day' && num(schedule_config.morning_to, 0) !== num(schedule_config.afternoon_from, 0);
    hours_section = /*#__PURE__*/React.createElement("div", {
      className: "c-booking-infos-card__element"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-booking-infos-card__element-label"
    }, "Cr\xE9neau\xA0:"), booking.start_hour === 'afternoon' ? 'Demi-journée - Après midi' : booking.start_hour === 'morning' ? 'Demi-journée - Matin' : 'Journée', ' (', booking.start_hour === 'morning' || lunch_break ? morning : undefined, lunch_break ? ' et ' : '', booking.start_hour === 'afternoon' || lunch_break ? afternoon : undefined, booking.start_hour === 'day' && !lunch_break ? [num(schedule_config.morning_from, 0) + 'h', num(schedule_config.afternoon_to, 0) + 'h'].join(' - ') : undefined, ')');
  } else {
    hours_section = /*#__PURE__*/React.createElement("div", {
      className: "c-booking-infos-card__element"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-booking-infos-card__element-label"
    }, "Cr\xE9neau\xA0:"), booking.start_hour, "h - ", booking.end_hour, "h");
  }
  const services_to_pay = (booking_services.rows || []).map(getServiceRow);
  return /*#__PURE__*/React.createElement("div", {
    className: bemit('c-booking-infos-card', props.bemit)
  }, space?.images?.[0] ? /*#__PURE__*/React.createElement(Image, {
    className: "c-booking-infos-card__img",
    src: variant({
      img: space?.images[0],
      size: 600
    }),
    alt: space?.name
  }) : /*#__PURE__*/React.createElement(Logo, {
    className: "c-booking-infos-card__img"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "c-booking-infos-card__title"
  }, space?._etablishment?.name, ", ", space?.name), space?._etablishment?.address ? /*#__PURE__*/React.createElement("div", {
    className: "c-booking-infos-card__element"
  }, space?._etablishment.address.hotel_name, ' - ', space?._etablishment.address.line_1, ', ', space?._etablishment.address.line_2 ? space?._etablishment.address.line_2 + ', ' : undefined, space?._etablishment.address.postal_code, '  ', space?._etablishment.address.city) : undefined, /*#__PURE__*/React.createElement("div", {
    className: "c-booking-infos-card__element"
  }, /*#__PURE__*/React.createElement("p", {
    className: "c-booking-infos-card__element-label"
  }, "Date\xA0:"), moment(booking.date).format("DD-MM-YYYY")), hours_section, space?.type === 'b_seminar' ? /*#__PURE__*/React.createElement("div", {
    className: "c-booking-infos-card__element"
  }, /*#__PURE__*/React.createElement("p", {
    className: "c-booking-infos-card__element-label"
  }, "Disposition\xA0:"), b_seminars_config[booking.disposition]?.title) : undefined, services.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "c-booking-infos-card__element is-services"
  }, /*#__PURE__*/React.createElement("p", {
    className: "c-booking-infos-card__element-label"
  }, "Service(s) additionnels\xA0:")), services_to_pay) : undefined, /*#__PURE__*/React.createElement("div", {
    className: "c-booking-infos-card__footer"
  }, /*#__PURE__*/React.createElement("p", {
    className: "c-booking-infos-card__price"
  }, "Total\xA0:", ' ', formatNum(booking_services?.amount, '0,0[.]00'), "\u20AC TTC")));
  function getServiceRow(service) {
    const qty = num(service.quantity, 0);
    const base_price = service.service_info?.unit === 'per_hour' ? num(num(service.total_price) / num(booking.hours_count, 0)) : num(num(service.total_price) / qty);
    amount_without_services = num(amount_without_services - num(service.total_price));
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-booking-infos-card__element is-service",
      key: service.service_info?.id
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-booking-infos-card__element-label"
    }, service.service_info?.unit === 'customer_qty' ? /*#__PURE__*/React.createElement("strong", null, qty + 'x ') : service.service_info?.unit === 'per_hour' ? /*#__PURE__*/React.createElement("strong", null, booking.hours_count + 'h ') : undefined, service.service_info?._servicetitle?.title || service.service_info?.title, qty > 1 || service.service_info?.unit === 'per_hour' ? ' (' + formatNum(base_price, '0,0.00') + '€)' : undefined, "\xA0:", /*#__PURE__*/React.createElement("strong", null, ' ' + service.total_price, "\u20AC")));
    return output;
  }
}
